const country: any = {
    'AU': 'AUD',
    'NZ': 'NZD',
};

const v = {
    country
};

export default v;